import { render, staticRenderFns } from "./backApprove.vue?vue&type=template&id=61cd90fd"
import script from "./backApprove.vue?vue&type=script&lang=js"
export * from "./backApprove.vue?vue&type=script&lang=js"
import style0 from "./backApprove.vue?vue&type=style&index=0&id=61cd90fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports